import axios from './BaseService';

const UPGRADE_REQUESTS_URL = `${
    process.env.REACT_APP_API_URL || window._env_?.REACT_APP_API_URL
}/upgrade-requests`;

export async function getUpgradePlans() {
    const response = await axios.get(`${UPGRADE_REQUESTS_URL}/plans`);
    return response.data;
}

export async function requestUpgrade(email, planId, note) {
    const response = await axios.post(UPGRADE_REQUESTS_URL, {
        email,
        planId,
        note,
    });
    return response.data; //{message}
}
